var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 639,
    viewBox: "0 0 428 639",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_146393)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_306_146393)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_306_146393)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4115 595.817C94.4115 595.817 90.2027 606.56 93.2645 608.413C106.935 616.687 147.921 623.502 188.897 625.02C246.168 627.14 309.38 624.716 336.061 614.139C338.449 613.193 341.591 609.269 342.363 606.694C343.943 601.414 341.216 596.389 341.216 596.389C341.216 596.389 265.436 603.258 197.502 603.258C142.583 603.258 94.4115 595.817 94.4115 595.817Z",
    fill: "url(#paint0_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.73 642.346H517.715L298.462 538L165.696 579.726L68.5878 642.346H-180H142.178L154.19 623.632L285.818 625.246L294.163 641.936L584.73 642.346Z",
    fill: "url(#paint1_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2988 644.369L199.835 558.387",
    stroke: "#070B36",
    strokeWidth: 1.01155
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.75 550.295L517.967 642.852L323.75 550.295Z",
    fill: "#070B36",
    stroke: "#070B36",
    strokeWidth: 1.01155
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.574 563.951L307.059 642.851L264.574 563.951Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.01155
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.1 595.289L473.207 620.947L465.62 624.623L450.447 624.118H332.096L420.1 595.289Z",
    fill: "url(#paint2_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.512 568.599L129.027 647.5",
    stroke: "black",
    strokeWidth: 1.01155
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.688 566.04C320.68 560.72 133.923 568.767 74.9422 568.901C54.4115 568.95 93.8392 596.39 93.8392 596.39L92.6967 607.842C92.6967 607.842 100.788 622.191 210.658 625.021C262.217 626.36 312.977 623.762 331.486 616.429C342.643 612.015 342.938 605.552 342.938 605.552L341.22 595.818C341.22 595.818 351.485 589.958 355.538 584.937C362.496 576.35 364.455 566.54 360.688 566.04Z",
    fill: "url(#paint3_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.688 566.04C320.68 560.72 133.923 568.767 74.9422 568.901C54.4115 568.95 93.8392 596.39 93.8392 596.39L92.6967 607.842C92.6967 607.842 100.788 622.191 210.658 625.021C262.217 626.36 312.977 623.762 331.486 616.429C342.643 612.015 342.938 605.552 342.938 605.552L341.22 595.818C341.22 595.818 351.485 589.958 355.538 584.937C362.496 576.35 364.455 566.54 360.688 566.04Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.313 600.462V623.222L142.174 642.189L132.564 641.683L154.313 600.462Z",
    fill: "#061833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.022 598.439L285.562 625.498L294.666 642.948H307.058L282.022 598.439Z",
    fill: "#061833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.681 622.21L153.362 601.234",
    stroke: "black",
    strokeWidth: 1.01155
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.856 617.364L130.176 601.027",
    stroke: "black",
    strokeWidth: 0.787854
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.565 622.969L153.807 599.975",
    stroke: "black",
    strokeWidth: 1.01155
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.813 625.245L283.285 598.963",
    stroke: "black",
    strokeWidth: 1.01155
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.82 599.099L305.5 638.5",
    stroke: "black",
    strokeWidth: 1.01155
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.092 597.161L326.369 626.423",
    stroke: "black",
    strokeWidth: 1.01155
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325.757,
    y1: 626.257,
    x2: 473.949,
    y2: 622.716,
    stroke: "black",
    strokeWidth: 1.01155
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.566 622.717L285.562 625.246L292.137 636.878L147.232 633.844L154.566 622.717Z",
    fill: "url(#paint4_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.815 602.315C139.176 602.409 93.5176 596.067 93.5176 596.067C93.5176 596.067 138.73 604.194 190.369 604.101C259.365 603.976 330.512 596.96 330.512 596.96C330.512 596.96 259.811 602.19 190.815 602.315Z",
    fill: "#000204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.815 602.315C139.176 602.409 93.5176 596.067 93.5176 596.067C93.5176 596.067 138.73 604.194 190.369 604.101C259.365 603.976 330.512 596.96 330.512 596.96C330.512 596.96 259.811 602.19 190.815 602.315Z",
    fill: "#070B36",
    stroke: "#010101",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.114 553.744C149.33 553.244 70.0821 561.376 69.2475 567.785C67.9354 577.85 134.722 579.483 215.492 579.483C296.263 579.483 358.528 573.976 361.733 568.37C367.307 558.631 336.445 554.4 230.114 553.744Z",
    fill: "url(#paint5_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.114 553.744C149.33 553.244 70.0821 561.376 69.2475 567.785C67.9354 577.85 134.722 579.483 215.492 579.483C296.263 579.483 358.528 573.976 361.733 568.37C367.307 558.631 336.445 554.4 230.114 553.744Z",
    fill: "url(#paint6_linear_306_146393)",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0884 569.735C101.772 569.735 105.568 568.436 105.568 566.834C105.568 565.231 101.772 563.933 97.0884 563.933C92.405 563.933 88.6084 565.231 88.6084 566.834C88.6084 568.436 92.405 569.735 97.0884 569.735Z",
    fill: "url(#paint7_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0884 569.735C101.772 569.735 105.568 568.436 105.568 566.834C105.568 565.231 101.772 563.933 97.0884 563.933C92.405 563.933 88.6084 565.231 88.6084 566.834C88.6084 568.436 92.405 569.735 97.0884 569.735Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.077 576.875C151.76 576.875 155.557 575.577 155.557 573.974C155.557 572.372 151.76 571.073 147.077 571.073C142.393 571.073 138.597 572.372 138.597 573.974C138.597 575.577 142.393 576.875 147.077 576.875Z",
    fill: "url(#paint8_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.077 576.875C151.76 576.875 155.557 575.577 155.557 573.974C155.557 572.372 151.76 571.073 147.077 571.073C142.393 571.073 138.597 572.372 138.597 573.974C138.597 575.577 142.393 576.875 147.077 576.875Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.825 573.751C303.508 573.751 307.305 572.452 307.305 570.85C307.305 569.248 303.508 567.949 298.825 567.949C294.141 567.949 290.345 569.248 290.345 570.85C290.345 572.452 294.141 573.751 298.825 573.751Z",
    fill: "url(#paint9_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.825 573.751C303.508 573.751 307.305 572.452 307.305 570.85C307.305 569.248 303.508 567.949 298.825 567.949C294.141 567.949 290.345 569.248 290.345 570.85C290.345 572.452 294.141 573.751 298.825 573.751Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.375 577.322C249.058 577.322 252.855 576.023 252.855 574.421C252.855 572.818 249.058 571.52 244.375 571.52C239.691 571.52 235.895 572.818 235.895 574.421C235.895 576.023 239.691 577.322 244.375 577.322Z",
    fill: "url(#paint10_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.375 577.322C249.058 577.322 252.855 576.023 252.855 574.421C252.855 572.818 249.058 571.52 244.375 571.52C239.691 571.52 235.895 572.818 235.895 574.421C235.895 576.023 239.691 577.322 244.375 577.322Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.957 578.214C202.64 578.214 206.437 576.915 206.437 575.313C206.437 573.711 202.64 572.412 197.957 572.412C193.273 572.412 189.477 573.711 189.477 575.313C189.477 576.915 193.273 578.214 197.957 578.214Z",
    fill: "url(#paint11_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.957 578.214C202.64 578.214 206.437 576.915 206.437 575.313C206.437 573.711 202.64 572.412 197.957 572.412C193.273 572.412 189.477 573.711 189.477 575.313C189.477 576.915 193.273 578.214 197.957 578.214Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.208 566.61C341.891 566.61 345.688 565.311 345.688 563.709C345.688 562.106 341.891 560.808 337.208 560.808C332.524 560.808 328.728 562.106 328.728 563.709C328.728 565.311 332.524 566.61 337.208 566.61Z",
    fill: "url(#paint12_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.208 566.61C341.891 566.61 345.688 565.311 345.688 563.709C345.688 562.106 341.891 560.808 337.208 560.808C332.524 560.808 328.728 562.106 328.728 563.709C328.728 565.311 332.524 566.61 337.208 566.61Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.538 517.363L167.709 526.526C167.709 526.526 193.149 527.812 219.25 527.673C246.921 527.526 275.365 525.955 275.365 525.955L283.399 517.363H154.538Z",
    fill: "url(#paint13_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.538 517.363L167.709 526.526C167.709 526.526 193.149 527.812 219.25 527.673C246.921 527.526 275.365 525.955 275.365 525.955L283.399 517.363H154.538Z",
    fill: "url(#paint14_linear_306_146393)",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.394 543.134C284.6 536.613 281.347 530.299 277.66 524.237L163.702 523.662L147.67 567.182C147.67 567.182 184.072 570.016 220.969 569.476C269.323 568.762 294.263 564.321 294.263 564.321C292.466 557.108 290.171 550.029 287.394 543.134Z",
    fill: "url(#paint15_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.394 543.134C284.6 536.613 281.347 530.299 277.66 524.237L163.702 523.662L147.67 567.182C147.67 567.182 184.072 570.016 220.969 569.476C269.323 568.762 294.263 564.321 294.263 564.321C292.466 557.108 290.171 550.029 287.394 543.134Z",
    fill: "url(#paint16_linear_306_146393)",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.524 545.995C182.777 545.995 156.257 543.705 156.257 543.705V544.294C175.068 546.54 193.994 547.687 212.939 547.731C247.676 547.731 287.385 544.294 287.385 544.294V543.723C287.385 543.723 248.113 545.995 213.524 545.995Z",
    fill: "#070B36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.524 545.995C182.777 545.995 156.257 543.705 156.257 543.705V544.294C175.068 546.54 193.994 547.687 212.939 547.731C247.676 547.731 287.385 544.294 287.385 544.294V543.723C287.385 543.723 248.113 545.995 213.524 545.995Z",
    fill: "#070B36",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.964 519.082C254.543 519.082 283.386 518.057 283.386 516.792C283.386 515.528 254.543 514.502 218.964 514.502C183.385 514.502 154.543 515.528 154.543 516.792C154.543 518.057 183.385 519.082 218.964 519.082Z",
    fill: "url(#paint17_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.967 518.51C153.075 519.282 150.687 521.37 147.438 524.053C150.49 521.531 145.679 530.699 134.494 538.549C126.51 544.159 117.494 540.049 117.316 550.002C117.276 552.108 113.584 564.284 115.597 566.038C123.631 572.969 148.808 566.609 148.808 566.609C148.808 566.609 155.605 552.202 156.842 544.293C163.09 536.871 167.718 526.543 167.718 526.543C167.718 526.543 156.868 515.957 153.967 518.51Z",
    fill: "url(#paint18_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.967 518.51C153.075 519.282 150.687 521.37 147.438 524.053C150.49 521.531 145.679 530.699 134.494 538.549C126.51 544.159 117.494 540.049 117.316 550.002C117.276 552.108 113.584 564.284 115.597 566.038C123.631 572.969 148.808 566.609 148.808 566.609C148.808 566.609 155.605 552.202 156.842 544.293C163.09 536.871 167.718 526.543 167.718 526.543C167.718 526.543 156.868 515.957 153.967 518.51Z",
    fill: "url(#paint19_linear_306_146393)",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.909 542.558C314.2 538.719 306.224 536.452 300.012 531.681C293.545 526.709 291.822 520.282 283.98 517.934C282.052 517.359 281.302 519.362 279.963 520.8C278.044 522.875 275.946 524.816 275.946 524.816C276.385 526.661 277.161 528.409 278.236 529.971C280.467 533.381 284.377 537.867 286.823 543.142C288.131 545.963 287.546 548.994 288.541 551.729C290.139 556.064 292.053 560.275 294.268 564.329C294.268 564.329 324.506 563.601 324.046 562.611C323.091 560.553 324.483 547.119 318.909 542.558Z",
    fill: "url(#paint20_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.909 542.558C314.2 538.719 306.224 536.452 300.012 531.681C293.545 526.709 291.822 520.282 283.98 517.934C282.052 517.359 281.302 519.362 279.963 520.8C278.044 522.875 275.946 524.816 275.946 524.816C276.385 526.661 277.161 528.409 278.236 529.971C280.467 533.381 284.377 537.867 286.823 543.142C288.131 545.963 287.546 548.994 288.541 551.729C290.139 556.064 292.053 560.275 294.268 564.329C294.268 564.329 324.506 563.601 324.046 562.611C323.091 560.553 324.483 547.119 318.909 542.558Z",
    fill: "url(#paint21_linear_306_146393)",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.259 210.448C126.814 209.466 116.75 226.48 116.75 226.48C116.75 226.48 112.662 235.495 125.908 246.524C129.796 249.76 125.855 255.16 133.942 256.829C148.862 259.9 194.342 244.551 212.378 245.359C246.003 246.872 286.605 257.905 307.444 254.522C318.646 252.706 320.614 235.625 320.614 235.625C320.614 235.625 313.183 211.341 223.259 210.448Z",
    fill: "url(#paint22_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.259 210.448C126.814 209.466 116.75 226.48 116.75 226.48C116.75 226.48 112.662 235.495 125.908 246.524C129.796 249.76 125.855 255.16 133.942 256.829C148.862 259.9 194.342 244.551 212.378 245.359C246.003 246.872 286.605 257.905 307.444 254.522C318.646 252.706 320.614 235.625 320.614 235.625C320.614 235.625 313.183 211.341 223.259 210.448Z",
    fill: "url(#paint23_linear_306_146393)",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.25 235.627C124.693 233.431 128.201 255.671 128.201 255.671C128.201 255.671 137.944 275.443 224.401 275.71C305.046 275.96 310.299 257.96 310.299 257.96C310.299 257.96 316.824 237.894 219.25 235.627Z",
    fill: "url(#paint24_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.25 235.627C124.693 233.431 128.201 255.671 128.201 255.671C128.201 255.671 137.944 275.443 224.401 275.71C305.046 275.96 310.299 257.96 310.299 257.96C310.299 257.96 316.824 237.894 219.25 235.627Z",
    fill: "url(#paint25_linear_306_146393)",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.81 243.07C140.775 243.288 147.666 260.82 147.666 260.82C147.666 260.82 154.914 274.633 216.399 275.709C291.461 277.025 290.845 261.395 290.845 261.395C290.845 261.395 295.701 242.837 215.81 243.07Z",
    fill: "url(#paint26_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.81 243.07C140.775 243.288 147.666 260.82 147.666 260.82C147.666 260.82 154.914 274.633 216.399 275.709C291.461 277.025 290.845 261.395 290.845 261.395C290.845 261.395 295.701 242.837 215.81 243.07Z",
    fill: "url(#paint27_linear_306_146393)",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.541 262.538C284.305 262.23 285.791 248.113 212.961 248.224C151.32 248.318 153.409 262.538 153.409 262.538L163.143 275.137C163.143 275.137 229.198 282.368 265.073 278.574C281.698 276.815 285.242 263.462 284.541 262.538Z",
    fill: "url(#paint28_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.541 262.538C284.305 262.23 285.791 248.113 212.961 248.224C151.32 248.318 153.409 262.538 153.409 262.538L163.143 275.137C163.143 275.137 229.198 282.368 265.073 278.574C281.698 276.815 285.242 263.462 284.541 262.538Z",
    fill: "url(#paint29_linear_306_146393)",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.669 284.873C275.867 264.874 157.218 266.632 157.976 282.584C158.735 298.535 285.213 302.088 281.669 284.873Z",
    fill: "url(#paint30_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.669 284.873C275.867 264.874 157.218 266.632 157.976 282.584C158.735 298.535 285.213 302.088 281.669 284.873Z",
    fill: "url(#paint31_linear_306_146393)",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.95 284.873L275.866 285.145C275.866 285.145 267.457 323.528 269.068 323.238C269.367 323.189 280.525 316.94 280.525 316.94L279.95 284.873Z",
    fill: "url(#paint32_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.95 284.873L275.866 285.145C275.866 285.145 267.457 323.528 269.068 323.238C269.367 323.189 280.525 316.94 280.525 316.94L279.95 284.873Z",
    fill: "url(#paint33_linear_306_146393)",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.667 279.146C281.667 278.7 276.267 264.842 214.666 265.976C162.295 266.944 157.983 277.428 157.983 277.428V283.154C157.983 283.154 263.859 286.506 280.529 284.873C281.962 284.734 281.667 279.28 281.667 279.146Z",
    fill: "url(#paint34_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.667 279.146C281.667 278.7 276.267 264.842 214.666 265.976C162.295 266.944 157.983 277.428 157.983 277.428V283.154C157.983 283.154 263.859 286.506 280.529 284.873C281.962 284.734 281.667 279.28 281.667 279.146Z",
    fill: "url(#paint35_linear_306_146393)",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.592 275.138C245.592 274.911 230.051 272.643 223.829 272.277L220.393 273.42V282.583C220.393 282.583 221.383 283.475 221.54 285.444C221.941 290.527 223.258 300.333 223.258 300.333L234.688 306.358L243.873 300.909C243.873 300.909 242.186 285.136 245.592 283.73C247.163 283.078 245.592 275.571 245.592 275.138Z",
    fill: "url(#paint36_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.592 275.138C245.592 274.911 230.051 272.643 223.829 272.277L220.393 273.42V282.583C220.393 282.583 221.383 283.475 221.54 285.444C221.941 290.527 223.258 300.333 223.258 300.333L234.688 306.358L243.873 300.909C243.873 300.909 242.186 285.136 245.592 283.73C247.163 283.078 245.592 275.571 245.592 275.138Z",
    fill: "url(#paint37_linear_306_146393)",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.857 283.729V290.026L169.428 306.058L166.567 313.503L172.294 314.078L175.73 306.045L176.302 290.013V283.729C176.302 283.269 168.857 283.729 168.857 283.729Z",
    fill: "url(#paint38_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.857 283.729V290.026L169.428 306.058L166.567 313.503L172.294 314.078L175.73 306.045L176.302 290.013V283.729C176.302 283.269 168.857 283.729 168.857 283.729Z",
    fill: "url(#paint39_linear_306_146393)",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.743 273.42L226.12 271.13L223.83 272.273V281.436L226.12 282.583L227.267 297.472L234.711 306.059L249.025 298.615V283.73L251.319 280.865L250.743 273.42Z",
    fill: "url(#paint40_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.743 273.42L226.12 271.13L223.83 272.273V281.436L226.12 282.583L227.267 297.472L234.711 306.059L249.025 298.615V283.73L251.319 280.865L250.743 273.42Z",
    fill: "url(#paint41_linear_306_146393)",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.068 285.443L268.497 318.658V321.524L275.942 316.003V285.216L269.068 285.443Z",
    fill: "url(#paint42_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.068 285.443L268.497 318.658V321.524L275.942 316.003V285.216L269.068 285.443Z",
    fill: "url(#paint43_linear_306_146393)",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.559 283.153C162.086 282.68 162.559 309.486 162.559 309.486L166.576 313.503C168.424 311.41 169.619 308.822 170.012 306.058C170.981 297.761 171.155 283.742 171.155 283.742C171.155 283.742 162.733 283.332 162.559 283.153Z",
    fill: "url(#paint44_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.559 283.153C162.086 282.68 162.559 309.486 162.559 309.486L166.576 313.503C168.424 311.41 169.619 308.822 170.012 306.058C170.981 297.761 171.155 283.742 171.155 283.742C171.155 283.742 162.733 283.332 162.559 283.153Z",
    fill: "url(#paint45_linear_306_146393)",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.71 500.757L163.693 495.03C163.693 495.03 159.471 500.449 159.676 500.757C159.881 501.064 158.975 517.859 159.676 517.935C160.528 518.029 166.406 520.225 167.71 517.364C169.999 512.289 167.71 500.757 167.71 500.757Z",
    fill: "url(#paint46_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.71 500.757L163.693 495.03C163.693 495.03 159.471 500.449 159.676 500.757C159.881 501.064 158.975 517.859 159.676 517.935C160.528 518.029 166.406 520.225 167.71 517.364C169.999 512.289 167.71 500.757 167.71 500.757Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.709 500.756V517.935L175.154 517.363V500.756H167.709Z",
    fill: "url(#paint47_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.709 500.756V517.935L175.154 517.363V500.756H167.709Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.721 495.03H163.688C163.688 495.03 166.767 502.475 167.704 502.475C169.092 502.475 174.444 504.037 175.149 501.904C175.64 500.444 171.721 495.03 171.721 495.03Z",
    fill: "url(#paint48_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.721 495.03H163.688C163.688 495.03 166.767 502.475 167.704 502.475C169.092 502.475 174.444 504.037 175.149 501.904C175.64 500.444 171.721 495.03 171.721 495.03Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.366 495.03H268.497L269.068 517.935H275.942L275.366 495.03Z",
    fill: "url(#paint49_linear_306_146393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.366 495.03H268.497L269.068 517.935H275.942L275.366 495.03Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.321 236.782L223.844 221.884L117.321 236.782Z",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.845 257.96C231.845 257.96 204.83 257.96 183.197 260.249C174.055 261.253 165.038 263.171 156.279 265.976C165.297 263.164 174.563 261.221 183.951 260.173C205.499 257.893 231.845 257.96 231.845 257.96Z",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.599 260.249L180.31 249.944L182.599 260.249Z",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.109 278.257L239.29 278.574M231.654 290.201L248.655 290.518",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.111 499.038C222.111 499.038 227.466 493.312 232.992 493.312C238.053 493.312 243.297 499.038 243.297 499.038V515.074C243.297 515.074 246.305 517.752 245.016 517.935C240.146 518.685 224.307 517.935 220.392 517.935C219.388 517.935 222.111 515.074 222.111 515.074V499.038Z",
    fill: "url(#paint50_linear_306_146393)",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.746 283.422L166.567 313.504",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.464 272.572V282.837",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.323 248.471V265.877M224.066 210.98V222.138M168.276 229.725V237.313",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.877 277.928V302.922",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.993 518.381L231.846 493.187L232.993 518.381Z",
    fill: "#070B36",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.074 542.063L226.043 523.983L226.074 542.063Z",
    fill: "#070B36",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.323 506.442L243.035 505.996L232.323 506.442Z",
    fill: "#070B36",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.076 512.852L271.934 495.098L273.076 512.852Z",
    fill: "#070B36",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.036 512.16L163.465 495.552L164.036 512.16Z",
    fill: "#070B36",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.572 568.9L237.001 559.737",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.837 559.555L248.614 553.307L248.391 547.058",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.611 560.447L221.388 554.199L221.165 547.95",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.968 554.586L154.538 551.721L220.968 554.586Z",
    fill: "#070B36",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.006 537.18L226.074 537.6",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.39 559.554L221.165 560.001",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -8,
    width: 484,
    height: 405,
    fill: "url(#paint51_linear_306_146393)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_306_146393",
    x1: 217.506,
    y1: 625.721,
    x2: 217.506,
    y2: 595.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000912",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000912"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_306_146393",
    x1: -645.509,
    y1: 393.226,
    x2: 719.972,
    y2: 188.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4254B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#081743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#001E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_306_146393",
    x1: 332.096,
    y1: 606.163,
    x2: 509.622,
    y2: 606.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#010E1E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_306_146393",
    x1: 69.0151,
    y1: 594.787,
    x2: 362.576,
    y2: 594.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#293869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1F51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_306_146393",
    x1: 218.799,
    y1: 623.728,
    x2: 218.799,
    y2: 633.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D1B38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_306_146393",
    x1: 70.2696,
    y1: 580.095,
    x2: 361.349,
    y2: 554.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_306_146393",
    x1: 70.2696,
    y1: 580.095,
    x2: 361.349,
    y2: 554.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F3370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_306_146393",
    x1: 88.6709,
    y1: 567.57,
    x2: 105.506,
    y2: 566.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_306_146393",
    x1: 138.597,
    y1: 573.974,
    x2: 155.557,
    y2: 573.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_306_146393",
    x1: 290.345,
    y1: 570.85,
    x2: 307.305,
    y2: 570.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_306_146393",
    x1: 235.895,
    y1: 574.421,
    x2: 252.855,
    y2: 574.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_306_146393",
    x1: 189.477,
    y1: 575.313,
    x2: 206.437,
    y2: 575.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_306_146393",
    x1: 328.728,
    y1: 563.709,
    x2: 345.688,
    y2: 563.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_306_146393",
    x1: 145.233,
    y1: 524.68,
    x2: 157.25,
    y2: 484.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_306_146393",
    x1: 145.233,
    y1: 524.68,
    x2: 157.25,
    y2: 484.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_306_146393",
    x1: 137.085,
    y1: 556.189,
    x2: 232.421,
    y2: 475.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_306_146393",
    x1: 137.085,
    y1: 556.189,
    x2: 232.421,
    y2: 475.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_306_146393",
    x1: 154.539,
    y1: 516.792,
    x2: 283.386,
    y2: 516.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08112B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08112B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_306_146393",
    x1: 141.354,
    y1: 569.274,
    x2: 141.354,
    y2: 518.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#172C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081649"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_306_146393",
    x1: 141.354,
    y1: 569.274,
    x2: 141.354,
    y2: 518.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#172C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081649"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_306_146393",
    x1: 274.165,
    y1: 539.273,
    x2: 326.13,
    y2: 545.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#041224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09214A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_306_146393",
    x1: 274.165,
    y1: 539.273,
    x2: 326.13,
    y2: 545.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#041224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09214A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_306_146393",
    x1: 101.39,
    y1: 243.605,
    x2: 198.94,
    y2: 130.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_306_146393",
    x1: 101.39,
    y1: 243.605,
    x2: 198.94,
    y2: 130.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_306_146393",
    x1: 115.028,
    y1: 264,
    x2: 198.348,
    y2: 163.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_306_146393",
    x1: 115.028,
    y1: 264,
    x2: 198.348,
    y2: 163.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_306_146393",
    x1: 137.145,
    y1: 266.263,
    x2: 205.266,
    y2: 186.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_306_146393",
    x1: 137.145,
    y1: 266.263,
    x2: 205.266,
    y2: 186.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_306_146393",
    x1: 143.925,
    y1: 270.52,
    x2: 209.812,
    y2: 197.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_306_146393",
    x1: 143.925,
    y1: 270.52,
    x2: 209.812,
    y2: 197.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_306_146393",
    x1: 162.373,
    y1: 299.258,
    x2: 277.273,
    y2: 268.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#051670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07133E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_306_146393",
    x1: 162.373,
    y1: 299.258,
    x2: 277.273,
    y2: 268.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#051670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07133E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_306_146393",
    x1: 268.021,
    y1: 312.071,
    x2: 280.981,
    y2: 311.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_306_146393",
    x1: 268.021,
    y1: 312.071,
    x2: 280.981,
    y2: 311.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_306_146393",
    x1: 149.051,
    y1: 279.671,
    x2: 184.859,
    y2: 219.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_306_146393",
    x1: 149.051,
    y1: 279.671,
    x2: 184.859,
    y2: 219.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_306_146393",
    x1: 218.523,
    y1: 296.438,
    x2: 246.355,
    y2: 290.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_306_146393",
    x1: 218.523,
    y1: 296.438,
    x2: 246.355,
    y2: 290.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_306_146393",
    x1: 165.864,
    y1: 305.184,
    x2: 176.675,
    y2: 304.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_306_146393",
    x1: 165.864,
    y1: 305.184,
    x2: 176.675,
    y2: 304.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_306_146393",
    x1: 221.845,
    y1: 295.892,
    x2: 251.305,
    y2: 289.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_306_146393",
    x1: 221.845,
    y1: 295.892,
    x2: 251.305,
    y2: 289.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_306_146393",
    x1: 267.96,
    y1: 310.955,
    x2: 276.262,
    y2: 310.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_306_146393",
    x1: 267.96,
    y1: 310.955,
    x2: 276.262,
    y2: 310.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_306_146393",
    x1: 161.713,
    y1: 304.667,
    x2: 171.505,
    y2: 303.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_306_146393",
    x1: 161.713,
    y1: 304.667,
    x2: 171.505,
    y2: 303.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_306_146393",
    x1: 159.426,
    y1: 506.929,
    x2: 168.727,
    y2: 506.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0C1A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_306_146393",
    x1: 167.709,
    y1: 509.347,
    x2: 175.154,
    y2: 509.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0C1A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_306_146393",
    x1: 163.701,
    y1: 499.029,
    x2: 175.198,
    y2: 499.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0C1A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_306_146393",
    x1: 268.497,
    y1: 506.483,
    x2: 275.942,
    y2: 506.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0C1A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_306_146393",
    x1: 218.353,
    y1: 511.004,
    x2: 244.618,
    y2: 503.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13214B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_306_146393",
    x1: 241,
    y1: -8,
    x2: 241,
    y2: 397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04183C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041736",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_146393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 428,
    height: 639,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_306_146393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 674.832,
    height: 503,
    fill: "white",
    transform: "translate(-135 136)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_306_146393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 691.841,
    height: 508.213,
    fill: "white",
    transform: "translate(-142.141 136)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverMobile);
export default __webpack_public_path__ + "static/media/over-mobile.315d50ec00708181338fa86d8044a40a.svg";
export { ForwardRef as ReactComponent };